import { render } from "./slide19.vue?vue&type=template&id=47764042&scoped=true"
import script from "./slide19.vue?vue&type=script&lang=js"
export * from "./slide19.vue?vue&type=script&lang=js"

import "./slide19.vue?vue&type=style&index=0&id=47764042&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47764042"]])

export default __exports__